export const saleMapper = {
  mapSales(data) {
    const mappedData = {
      ...data,
      value: Number(data.value),
      breuvage: Number(data.breuvage),
      escompte: Number(data.escompte),
      livraison: Number(data.livraison),
      value_before_tx: Number(data.value_before_tx),
      tps: Number(data.tps),
      tvq: Number(data.tvq),
      value_after_tx: Number(data.value_after_tx)
    };
    return mappedData;
  },
  mapSalesEstimates(data) {
    const mappedData = {
      ...data,
      value: Number(data.value)
    };
    return mappedData;
  }
};
